/**
 * Form review must not show an approval action until the same, current
 * tenant-scoped submission's server-calculated schema state is known.
 * The server's POST verification remains authoritative.
 */
export const formReviewActionState = (submissionId, review) => {
  if (!submissionId || review?.submissionId !== submissionId) return 'checking';
  if (review?.error) return 'unavailable';
  const state = review?.schema?.state;
  const blocked = review?.schema?.approval_blocked;
  if (typeof blocked !== 'boolean' ||
      !['current', 'grandfathered', 'not_applicable', 'awaiting_upgrade'].includes(state)) {
    return 'unavailable';
  }
  // Conflicts are a verification failure, not proof of an approval-ready form.
  if ((state === 'awaiting_upgrade') !== blocked) return 'unavailable';
  return blocked ? 'needs_current_form' : 'ready';
};
